module.exports = __webpack_public_path__ + "images/emoji/stuck_out_tongue_winking_eye.3727bf9b49165783a6dd.png";